import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'questionnaire-head-photo',
  templateUrl: './questionnaire-head-photo.component.html',
  styleUrls: ['./questionnaire-head-photo.component.css']
})

export class QuestionnaireHeadPhotoComponent implements OnInit, AfterViewInit {
  @Input() questionnaireLevel: number; //问卷等级
  @Input() questionnaireHeadPhotoUrlArray: any; //问卷头像url

  origin: string; //origin
  constructor(private platformLocation: PlatformLocation) {}

  ngOnInit() {
    this.origin = this.platformLocation['location']['origin'];
  }

  ngAfterViewInit(){

  }


}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-head-photo/questionnaire-head-photo.component.ts